var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.622,
    height: 17.756,
    viewBox: "0 0 18.622 17.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462",
    transform: "translate(12720.086 -4539.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_note-2",
    "data-name": "vuesax/outline/note-2",
    transform: "translate(-12829.156 4286.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-2",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.31,15.963a6.827,6.827,0,0,1-.71-.035,9.39,9.39,0,0,1-1.49-.251l-1.455-.346C.661,14.387-.647,12.273.289,8.288l.849-3.629a9.206,9.206,0,0,1,.693-2.044C3.32-.46,6.17-.183,8.2.293L9.644.631c2.027.476,3.309,1.23,4.028,2.382s.823,2.633.346,4.66l-.849,3.621C12.424,14.464,10.874,15.963,8.31,15.963ZM5.98,1.3A2.994,2.994,0,0,0,3,3.178a8.8,8.8,0,0,0-.6,1.776L1.553,8.583c-.771,3.274.121,4.7,3.4,5.483l1.455.346a8.926,8.926,0,0,0,1.308.217c2.356.234,3.525-.8,4.184-3.629l.849-3.621c.39-1.672.338-2.841-.182-3.681S11.021,2.286,9.341,1.9L7.894,1.558A8.3,8.3,0,0,0,5.98,1.3Z",
    transform: "translate(5.385 1.517)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.146,15.5c-2.226,0-3.647-1.334-4.556-4.149L.48,7.931C-.75,4.12.351,1.972,4.145.742L5.513.3A9.027,9.027,0,0,1,6.6.014a.627.627,0,0,1,.641.243.672.672,0,0,1,.069.684,8.073,8.073,0,0,0-.589,1.767L5.877,6.337c-.771,3.274.121,4.7,3.4,5.483l1.455.346a8.926,8.926,0,0,0,1.308.217.666.666,0,0,1,.58.485.651.651,0,0,1-.26.7,8.568,8.568,0,0,1-2.2,1.013l-1.369.45A8.911,8.911,0,0,1,6.146,15.5ZM5.669,1.616,4.552,1.98c-3.092,1-3.829,2.451-2.833,5.552l1.109,3.422c1,3.092,2.46,3.837,5.552,2.841l1.369-.45c.052-.017.1-.035.147-.052l-.918-.217c-3.993-.944-5.3-3.058-4.366-7.042L5.461,2.4C5.522,2.128,5.591,1.859,5.669,1.616Z",
    transform: "translate(1.07 3.771)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.853,2.358a1.184,1.184,0,0,1-.165-.017L.487,1.276A.648.648,0,0,1,.808.02l4.2,1.065a.647.647,0,0,1-.156,1.273Z",
    transform: "translate(10.297 6.745)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.173,1.934a1.184,1.184,0,0,1-.165-.017L.487,1.276A.648.648,0,1,1,.808.02L3.329.661a.649.649,0,0,1,.468.788A.631.631,0,0,1,3.173,1.934Z",
    transform: "translate(9.439 10.098)",
    fill: "#061133"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCard);
export default __webpack_public_path__ + "static/media/double-card.f387bdaa3581722a1c9339e5611b416e.svg";
export { ForwardRef as ReactComponent };